import React from 'react';
import { AdminLocationCreateDto } from '../../../../types/admin.types';

interface VenueFormFieldsProps {
    form: AdminLocationCreateDto;
    onChange: (next: AdminLocationCreateDto) => void;
    fieldClassName: string;
    idPrefix?: string;
    requiredName?: boolean;
}

export const emptyVenueForm: AdminLocationCreateDto = {
    name: '',
    city: '',
    region: '',
    country: '',
    venueUrl: ''
};

export const normalizeVenueCreatePayload = (form: AdminLocationCreateDto): AdminLocationCreateDto => ({
    name: (form.name ?? '').trim(),
    city: form.city && form.city.trim().length > 0 ? form.city.trim() : null,
    region: form.region && form.region.trim().length > 0 ? form.region.trim() : null,
    country: form.country && form.country.trim().length > 0 ? form.country.trim() : null,
    venueUrl: form.venueUrl && form.venueUrl.trim().length > 0 ? form.venueUrl.trim() : null
});

const VenueFormFields = ({
    form,
    onChange,
    fieldClassName,
    idPrefix = 'location',
    requiredName = true
}: VenueFormFieldsProps) => (
    <>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-name`}>Name</label>
            <input
                id={`${idPrefix}-name`}
                value={form.name}
                onChange={(event) => onChange({ ...form, name: event.target.value })}
                maxLength={200}
                required={requiredName}
            />
        </div>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-city`}>City</label>
            <input
                id={`${idPrefix}-city`}
                value={form.city ?? ''}
                onChange={(event) => onChange({ ...form, city: event.target.value })}
                maxLength={200}
            />
        </div>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-region`}>Region</label>
            <input
                id={`${idPrefix}-region`}
                value={form.region ?? ''}
                onChange={(event) => onChange({ ...form, region: event.target.value })}
                maxLength={200}
            />
        </div>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-country`}>Country</label>
            <input
                id={`${idPrefix}-country`}
                value={form.country ?? ''}
                onChange={(event) => onChange({ ...form, country: event.target.value })}
                maxLength={200}
            />
        </div>
        <div className={fieldClassName}>
            <label htmlFor={`${idPrefix}-venue-url`}>Venue URL</label>
            <input
                id={`${idPrefix}-venue-url`}
                value={form.venueUrl ?? ''}
                onChange={(event) => onChange({ ...form, venueUrl: event.target.value })}
                maxLength={2000}
            />
        </div>
    </>
);

export default VenueFormFields;
